import React from "react";
import CrossIcon from "../../assets/icons/sign/cross.svg";
import COLORS from "../../constants/colors";
import IconWrapper from "../IconWrapper";
import styled from "styled-components";
import { flexCenter } from "../../mixins/style-mixins";
export const CloseIconWrapper = styled.div`
    ${flexCenter}
    display: inline-flex;
    background-color: ${COLORS.GREY_200};
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
`;

interface CloseButtonProps {
    onClick?: () => void;
}
const CloseButton = ({ onClick }: CloseButtonProps) => {
    return (
        <CloseIconWrapper onClick={onClick}>
            <IconWrapper>
                <CrossIcon fill={COLORS.GREY_900} />
            </IconWrapper>
        </CloseIconWrapper>
    );
};

export default CloseButton;
